import React, { Component } from 'react'
import SelectList from '../SelectList'
import DossierQueryModal from '../Modals/DossierQueryModal'
import { FormControl, Box } from '@mui/material'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'

export default class DossierQuerySelect extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: this.props.value,
        }

        this.onChange = this.onChange.bind(this)
    }

    onChange(id, item) {
        this.setState({ value: id })
        if (this.props.onChange) {
            this.props.onChange(id, item)
        }
    }

    render() {
        const kedo = this.props.kedo

        let urlParams = {
            environment: kedo.env().getEnvironment().id,
            view: this.state.view,
            defDossier: this.props.ddId,
        }

        let newItem = {
            defDossier: this.props.ddId,
        }

        return (
            <FormControl fullWidth margin="normal">
                <FormInputLabel
                    className={this.props.required ? 'required' : ''}
                >
                    {this.props.label || kedo.t('Query')}
                </FormInputLabel>
                <SelectList
                    detailUrl={`/querybuilder/${this.state.value}`}
                    currentValue={this.state.value}
                    onClear={() => this.onChange(null)}
                    disableInit={true}
                    searchName={'search'}
                    kedo={kedo}
                    addComponent={(onSuccess, onClose) => (
                        <DossierQueryModal
                            type={this.props.type}
                            onSuccess={onSuccess}
                            onClose={onClose}
                            item={newItem}
                            kedo={kedo}
                            ddId={this.props.ddId}
                        />
                    )}
                    editComponent={(onClose) => (
                        <DossierQueryModal
                            onClose={onClose}
                            ddId={this.props.ddId}
                            kedo={kedo}
                            id={this.state.value}
                        />
                    )}
                    urlParams={urlParams}
                    onDisplayName={(item) => {
                        return (
                            <span>
                                {item.id}:{' '}
                                {kedo.env().translateItem(item, 'dossierquery')}{' '}
                                {item.def_dossier_def_field &&
                                item.def_dossier_def_field.def_field ? (
                                    <Box
                                        component={'small'}
                                        sx={{ float: 'right' }}
                                        title={`Data field: ${item.def_dossier_def_field.id}`}
                                        className={'badge badge-secondary'}
                                    >
                                        {
                                            item.def_dossier_def_field.def_field
                                                .type
                                        }
                                    </Box>
                                ) : null}
                            </span>
                        )
                    }}
                    url={kedo.api().getDossierQueryEndpoint()}
                    onSelect={(item) => this.onChange(item.id, item)}
                />
            </FormControl>
        )
    }
}
